import script from "./object_headerV1.vue?vue&type=script&setup=true&lang=js"
export * from "./object_headerV1.vue?vue&type=script&setup=true&lang=js"

import "./object_headerV1.vue?vue&type=style&index=0&id=079ebeb8&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079ebeb8"]])

export default __exports__